// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"176":"290d3e56","200":"fe5cf6a1","716":"a2aa2d45","919":"99e0fd7a","936":"465489fd"}[chunkId] + ".chunk.js";
};